import Material from './Material'

export default class Querschnitt{
    /**
     * Klasse für Querschnitte
     * @param {*} list 
     * @param {Number} fläche 
     * @param {Number} trägheitsmoment 
     * @param {Material} material 
     * @param {String} name 
     */
    constructor(list, fläche, trägheitsmoment, material, name){
        this._name = name || 'neuer Querschnitt'
        this.Fläche = fläche
        this.Trägheitsmoment = trägheitsmoment
        this.Material = material
        this.Stabliste = []
        this.list = list || null
    }
    get name() { return this._name }
    get materialName() { return this.Material ? this.Material.name : null}
    get EA() { return this.Material.Emodul * this.Fläche }
    get EI() { return this.Material.Emodul * this.Trägheitsmoment }
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    set name(v) { this._name = v }
    release_bindings(){ 
        if (this.Material) this.Material.delete_Querschnittverknüpfung(this) 
    }
    add_Stabverknüpfung(stab){this.Stabliste.push(stab)}
    delete_Stabverknüpfung(stab){
        if (this.Stabliste.indexOf(stab)==-1) return console.log('Stab nicht in Liste')
        this.Stabliste.splice(this.Stabliste.indexOf(stab),1)}
}


